import { ContentPageTableHeader } from "../shared/components/tables/ContentPageTableHeader";
import React from "react";
import { useTranslation } from "react-i18next";
import { PaginatedContentPageTable } from "../shared/components/tables/PaginatedContentPageTable";
import { getAllAuditEvents } from "./audit-log/AuditEventsApi";
import { formatDateShort, parseDate } from "../shared/technical/dateTime/dateFormatter";
import { MUIDataTableColumn } from "mui-datatables";
import {
  displayDateRangeFilter,
  handleCreatedAtParamsChange,
  renderDateRangeFilter,
  updateDateRangeFilter
} from "./audit-log/DateRangeFilter";

const columns: MUIDataTableColumn[] = [
  { name: "id", label: "Event Id", options: { filter: false, } },
  { name: "action", label: "action", options: { filter: true } },
  {
    name: "entity",
    label: "entity",
    options: {
      filter: true,
      filterType: 'dropdown',
      filterOptions: {
        names: [ 'AccountServiceUserDto', 'ApplicationDto', 'CompanyDto', 'LicenseDto' ]
      }
    }
  },
  {
    name: "entityId",
    label: "entityId",
    options: {
      filter: true,
      filterType: 'textField'
    }
  },
  { name: "changes", label: "changes", options: { filter: false } },
  { name: "createdBy.email", label: "Event Owner", options: { filter: false } },
  {
    name: "createdAt",
    label: "Event Date",
    options: {
      filter: true,
      customBodyRender: (value: string) => formatDateShort(parseDate(value)),
      customFilterListOptions: {
        render: renderDateRangeFilter,
        update: updateDateRangeFilter,
      },
      filterType: 'custom',
      filterOptions: {
        display: displayDateRangeFilter
      }
    }
  },
];

export function AuditLogPage() {
  const { t } = useTranslation();

// Wrap the API call to transform parameters
  function wrappedGetAllAuditEvents(axios: any, pageable: any, params?: string) {
    const transformedParams = params ? handleCreatedAtParamsChange(params) : undefined;
    return getAllAuditEvents(axios, pageable, transformedParams);
  }

  return (
    <>
      <ContentPageTableHeader onClick={() => {
      }}
                              title={t('AuditLog.titleLong')}
                              titleButton={t('AuditLog.buttonCreate')}
                              isEditable={false}
                              sx={{ marginTop: 2 }}
      />
      <PaginatedContentPageTable
        pagedQuery={wrappedGetAllAuditEvents}
        columns={columns}
        handleRowClick={() => {
        }}
        dataVersion={1}
        tableOptions={{ filter: true }}
      />
    </>
  )
}
